import queryString from "query-string";
import { removeEmptyParams } from "helpers";
import {
  privateFetch,
  privateFetchNoBody,
  privateFetchWithToken,
} from "./fetch";

export const getInvoicesForApp = async (appId, accessToken) => {
  const url = __BASE_API_URL__ + `/app/${appId}/invoices`;

  if (accessToken) {
    try {
      const result = privateFetchWithToken(url, {
        method: "GET",
        headers: new Headers({
          "Content-Type": "application/json",
          Authorization: accessToken,
        }),
      });

      return result;
    } catch (e) {
      console.error(e);
    }
  }

  try {
    const result = privateFetch(url, {
      method: "GET",
    });

    return result;
  } catch (e) {
    console.error(e);
  }
};
